document.addEventListener('DOMContentLoaded', () => {
    const faqAnswer = document.querySelector('.faq-answers');
    const pageTitle = faqAnswer.dataset.title;
    const allFaqQuestionGroups = Array.from(document.querySelectorAll('.faq-question-group'));
    const questionGroupBreadcrumb = document.querySelector('.question-group-breadcrumb');
    const categoryBreadcrumb = document.querySelector('.category-breadcrumb');
    const breadcrumbData = [];

  

    // Get URL parameters
    const params = new URLSearchParams(window.location.search);
    const questionGroupParam = params.get('question_group');
    const categoryParam = params.get('category');

    if(categoryParam === null){
      const categoryBreadcrumbContainer = document.querySelector('.category-breadcrumb-container');
      categoryBreadcrumbContainer.classList.add('hidden');
    }

    // Loop through all questions and add 'active' if it matches questionGroupParam
    allFaqQuestionGroups.forEach((group) => {
      const formattedQuestionGroupName = group.dataset.name.trim().toLowerCase().replace(/\s+/g, '-');
      if (formattedQuestionGroupName === questionGroupParam) {
        group.classList.add('active');

        const groupLinks = Array.from(group.querySelectorAll('.faq-link'));
        groupLinks.forEach((link) => {
          const formattedCategoryName = link.dataset.name.trim().toLowerCase().replace(/\s+/g, '-');
          if (formattedCategoryName === categoryParam) {
            link.classList.add('active');
          }
        });
      }else{
        group.addEventListener('click', function () {
          const url = group.getAttribute('data-url');
          if (url) {
            window.location.href = url;
          }
        });
      }
    });

    //Store the pages names and links for the breadcrumb
    allFaqQuestionGroups.forEach((group) => {
      const groupName = group.dataset.name;
      const groupURL = group.dataset.url;
  
      const groupLinks = Array.from(group.querySelectorAll('.faq-link')).map((link) => ({
        name: link.dataset.name,
        url: link.dataset.url
      }));
  
      breadcrumbData.push({
        name: groupName,
        url: groupURL,
        links: groupLinks
      });
    });

    //Sets breadcrumb text and url
    breadcrumbData.forEach((group) => {
      const formattedGroupName = group.name.trim().toLowerCase().replace(/\s+/g, '-');
    
      if (formattedGroupName === questionGroupParam) {
        questionGroupBreadcrumb.innerHTML =  group.name;
        questionGroupBreadcrumb.href =  group.url;
    
        const matchedLink = group.links.find(link => 
          link.name.trim().toLowerCase().replace(/\s+/g, '-') === categoryParam
        );
    
        if (matchedLink) {
          categoryBreadcrumb.innerHTML =  matchedLink.name;
          categoryBreadcrumb.href =  matchedLink.url;
        }
      }
    });
      // Clean URL - remove query parameters after navigation is set
    if (window.location.search.includes('question_group') || window.location.search.includes('category')) {
      window.history.replaceState({}, '', window.location.pathname);
    }
// Clean URLs in navigation links
document.querySelectorAll('.faq-link, .faq-question-group').forEach(el => {
  const href = el.getAttribute('href') || el.getAttribute('data-url');
  if (href && href.includes('?')) {
    const cleanUrl = href.split('?')[0];
    if (el.hasAttribute('href')) el.setAttribute('href', cleanUrl);
    if (el.hasAttribute('data-url')) el.setAttribute('data-url', cleanUrl);
  }
});
});